import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/recommendAwards/records/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recommendAwards/records',
    meta: {
      title: '推荐记录'
    }
  }
]
